import { customActions } from './custom-actions';
import { createServiceStore } from 'common/store';
import { INITIAL_STATE } from './constants';
export var useChatMessagesStore = createServiceStore({
    initialValues: INITIAL_STATE,
    customActions: customActions,
});
